module.exports = __webpack_public_path__ + "img/start.e927fd22.svg";